import type { Nullable } from "@bounce/util"

type UseReviewCountArgs = {
  store: Nullable<{ reviewCount: number }>
  truncate?: boolean
}

export const useReviewCount = ({ store, truncate = true }: UseReviewCountArgs) => {
  if (!store) {
    return null
  }

  const { reviewCount } = store

  if (!truncate || reviewCount < 500) {
    return `${reviewCount}`
  }

  const truncated = Math.floor(reviewCount / 500) * 500

  return `${truncated}+`
}
